import { HttpClient, HttpEventType, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonModalComponent } from '../modules/common/common-modal/common-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../modules/masters/dialog/dialog.component';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  baseUrl = environment.baseUrl;
  baseurlLogin = 'https://sdmapibeta.vertexplus.com/EmployeeCore/api/';
  exceptionText = 'There are some exception error, Please contact to support team.';
  userInfo = new BehaviorSubject({});
  constructor(
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog
  ) { }
  postService(data: any, url: any): Observable<any> {
    const user = JSON.parse(localStorage.getItem('dms_uid'));
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user
    });
    return this.http.post(this.baseUrl + url, data, {
      headers: httpHeaders,
      observe: 'response'
    }).pipe(
      catchError(err => {
        this.spinner.hide();
        const dialogRef = this.dialog.open(CommonModalComponent, {
          width: '300px',
          disableClose: true,
          autoFocus: false,
          panelClass: 'statusClass',
          data: { action: 'delete', statusText: this.exceptionText }
        });
        return throwError(err);
      })
    )
  }
  //Login
  login(data: any, url: any): Observable<any> {
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.post(this.baseurlLogin + 'login/' + url, data,
      {
        headers: httpHeaders,
        observe: 'response'
      });
  }
  //File upload
  //Multiple Image Upload
  imageUpload(fileEvent: any, data): Observable<any> {


    const file = fileEvent.target.files[0];

    const fileName = file.name;
    const fileExe = fileName.split('.').pop();
    console.log(fileExe);


    const fileSize = file.size / (1024 * 1024);

    if (fileSize > 50000) {
      return new Observable(
        res => {
          data.DocumentFileName = '';
          data.imagePreview = '';
          data.FileData = '';
          data.FileExe = '';
          data.percentDone = 0;
          data.documentsize = '';
          data.errorText = 'File size should be less than 5MB';
          res.next(data);
        }
      )
    } else {
      return new Observable(
        res => {
          //Process bar
          var formData = new FormData();
          Array.from(fileEvent.target.files).forEach((faa: any) => { formData.append('file', faa) })

          this.http.post('https://file.io', formData, { reportProgress: true, observe: 'events' })
            .subscribe(event => {
              console.log(event);
              
              if (event.type === HttpEventType.UploadProgress) {
                //this.percentDone = Math.round(100 * event.loaded / event.total);

                const files = fileEvent.target.files;

                const file = files[0];

                if (files && file) {
                  const fileName = file.name;

                  const fileExe = fileName.split('.').pop();
                  let reader = new FileReader();
                  reader.onload = (e: any) => {
                    let imagePreview = e.target.result;
                    console.log(imagePreview);
                    
                    let b;
                    b = imagePreview.split('base64,');
                    data.documentName = fileName;
                    data.imagePreview = imagePreview;
                    console.log(data.imagePreview);
                    
                    data.documentData = b[1];
                    data.documentType = fileExe;
                    let docSize = fileSize;
                    data.documentsize = (docSize * 1024).toString()
                    // element.documentsize = (res.documentsize * 1024).toString()

                    data.percentDone = Math.round(100 * event.loaded / event.total);
                    data.errorText = '';
                    res.next(data)
                  }
                  reader.readAsDataURL(file);
                }

              } else if (event instanceof HttpResponse) {
                //data.uploadSuccess = true;
              }
            });


        }
      )
    }
  }
  //Common Popup
  alertPopup(action, message) {
    const dialogRef = this.dialog.open(CommonModalComponent, {
      width: '300px',
      disableClose: true,
      autoFocus: false,
      panelClass: 'statusClass',
      data: { action: action, statusText: message }
    });
  }
  //File View
  docViewDetail(data) {
    const dialogRef = this.dialog.open(DialogComponent, {
      panelClass: 'viewdoc-width',
      autoFocus: false,
      data: { action: 'viewDoc', data: data }
    })
  }
  docViewDetail2(data) {
    return new Promise(resolve => {
        const dialogRef = this.dialog.open(DialogComponent, {
          panelClass: 'viewdoc-width',
          autoFocus: false,
          data: { action: 'viewDoc', data: data }
        })
        dialogRef.afterClosed().subscribe(async (result) => {
          if (result) {
                resolve(result);            
          }
        })
    });
  }
  download(url: string): Observable<Blob> {
    return this.http.get(url, {
      responseType: 'blob'
    })
  }
}
